(function($){
	document.addEventListener('DOMContentLoaded', ()=> {


		$('.js-form-spoiler').each((index, item) => {
			$(item).on('click', ()=> {
				const $spoiler = $(item);
				if (!$spoiler.length) return;

				if ($spoiler.hasClass('form-spoiler--open')) {
					$spoiler.removeClass('form-spoiler--open');
				} else {
					$spoiler.addClass('form-spoiler--open');
				}
			});
		});
	});
// eslint-disable-next-line no-undef
})(jQuery);
